<template>
  <section class="section brief">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="10" md="8" lg="6">
          <h2 id="the-brief" class="brief__title title-1">The Brief</h2>
          <p id="the-brief-desc" class="brief__description body-2">
            Our friends at Adobe and Google asked us to build a plugin
            that would make it faster and easier to translate a stunning
            Adobe XD design into working, high-quality Flutter code.
          </p>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Brief",
  };
</script>

<style scoped lang="scss">
  @import "../variables";

  .brief {
    &__title {
      color: $title;
    }

    &__description {
      color: $body-3;
      margin-bottom: pxToRem(96);
    }
  }
</style>
